import React, { useCallback, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../Components/Navbar/Navbar';
import Footer from '../Components/Footer/Footer';
import BtnWhatsapp from '../Components/BtnWhatsapp/BtnWhatsapp';
import Cart from '../Components/Cart/Cart';
import TitleMeta from '../Components/TitleMeta/TitleMeta';
import InstallAppButton from '../Components/InstallApp/InstallAppButton';
import InputSearchs from '../Components/InputSerach/InputSearchs';
import PublicNavigation from '../Components/PublicNavigation/PublicNavigation';
import CatalogDataProvider from '../Components/CatalogData/CatalogDataProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './PublicAppShell.css';

export default function PublicAppShell() {
    const { pathname } = useLocation();
    const [activeOverlay, setActiveOverlay] = useState(null);
    const [cartCount, setCartCount] = useState(0);
    const searchButtonRef = useRef(null);
    const cartButtonRef = useRef(null);
    const normalizedPathname = `/${pathname.split('/').filter(Boolean).join('/')}`;
    const isHomePage = normalizedPathname === '/';

    const closeOverlay = useCallback(() => {
        setActiveOverlay(null);
    }, []);

    const navigation = (
        <PublicNavigation
            cartButtonRef={cartButtonRef}
            cartCount={cartCount}
            onOpenCart={() => setActiveOverlay('cart')}
            onOpenSearch={() => setActiveOverlay('search')}
            searchButtonRef={searchButtonRef}
        />
    );

    return (
        <CatalogDataProvider>
            <div className="public-app-shell">
                <ToastContainer />
                <TitleMeta />
                <Navbar navigation={navigation} />
                <InputSearchs
                    isOpen={activeOverlay === 'search'}
                    onAfterClose={() => searchButtonRef.current?.focus()}
                    onRequestClose={closeOverlay}
                />
                <div className="public-app-shell__content">
                    <Outlet />
                </div>
                <Cart
                    isOpen={activeOverlay === 'cart'}
                    onAfterClose={() => cartButtonRef.current?.focus()}
                    onCartCountChange={setCartCount}
                    onRequestClose={closeOverlay}
                />
                <BtnWhatsapp />
                {isHomePage && <InstallAppButton variant="floating" />}
                <Footer />
            </div>
        </CatalogDataProvider>
    );
}
